import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges } from '@angular/core';

import { AppInfoConfig, ProductService } from '@frontend/vanilla/core';
import { PageMatrixComponent } from '@frontend/vanilla/features/content';

import { SeoboxesService } from './seoboxes.service';

@Component({
    selector: 'bg-seoboxes',
    templateUrl: 'seoboxes.component.html',
    imports: [
        CommonModule,
        //VanillaCoreModule,
        //ContentModule
        PageMatrixComponent,
    ],
})
export class SeoboxesComponent implements OnChanges {
    @Input() categoryName: string;
    @Input() timestamp: number;
    currentProduct: string;

    id: number = 1;
    seoboxes: any = [];

    constructor(
        private SeoService: SeoboxesService,
        private productService: ProductService,
        private appInfoConfig: AppInfoConfig,
    ) {
        this.currentProduct = this.productService.isSingleDomainApp ? this.productService.current?.name : this.appInfoConfig?.product?.toLowerCase();
    }

    ngOnChanges(): void {
        this.SeoService.getSeoboxes(this.categoryName).subscribe((response: any) => {
            this.seoboxes = response.content;
        });
    }
}
